'use client';
import { useCallback, useEffect, useState } from 'react';

export function useLocalStorage() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const getStorage = useCallback(
    (key: string) => {
      if (!isClient) return null;
      return localStorage.getItem(key);
    },
    [isClient],
  );

  const setStorage = useCallback(
    (key: string, value: string) => {
      if (!isClient) return;
      localStorage.setItem(key, value);
    },
    [isClient],
  );

  const removeStorage = useCallback(
    (key: string) => {
      if (!isClient) return;
      localStorage.removeItem(key);
    },
    [isClient],
  );

  return {
    getStorage,
    setStorage,
    removeStorage,
  };
}
